<template>
  <div>
    <div><van-nav-bar left-text="返回" left-arrow @click-left="onClickLeft" title="MCDEX时讯"></van-nav-bar></div>
    <div class="set" @click="switchto">设置</div>
    <!-- <div class="save" @click="switchto">设置</div> -->
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',  
  data () {
    return {

    }
  },
  created(){
  },
  methods:{    
    onClickLeft(){
      this.$router.push({ name: "Dept" });
    },
    switchto(){
        this.$router.push({name: "ScanDetail"});
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.set{
    /* font-size: 0.18rem;
    text-align: center;
    font-weight: 700;
    background: #F2EEEE;
    height: 0.45rem;
    line-height: 0.45rem;
     background: #07c160;
    color: #fff; */
     font-size: 0.16rem;
    background: #07c160;
    color: #fff;
    text-align: center;
    height: 0.4rem;
    line-height: 0.4rem;
    border-radius: 0.2rem;
    width: 80%;
    margin-left: 10%;
    margin-top: 0.05rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Scan.vue